<template>
  <v-container
    class="mt-5"
    style="height: 60vh;"
  >
    <!-- head -->
    <v-row justify="space-between">
      <!-- Title -->
      <v-col cols="6">
        <base-title no-margin-top>ROR Cases</base-title>
        <p class="primary--text text-caption">
          {{ total }} Cases
        </p>
      </v-col>
      <!-- search field -->
      <v-col cols="3">
        <v-text-field
          v-model="filter.search"
          dense
          rounded
          outlined
          prepend-inner-icon="mdi-magnify"
          placeholder="Search"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- case sorter -->
    <v-row>
      <v-col cols="3">
        <v-select
          v-model="filter.sort.value"
          flat
          dense
          hide-details=""
          :items="filter.sort.options"
        ></v-select>
      </v-col>
    </v-row>

    <!-- loading bar -->
    <v-row
      v-if="loading"
      justify="center"
      align="center"
      class="fill-height"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-row>
    <!-- case list -->
    <v-row v-else>
      <v-col
        v-for="(caseInfo, index) in filteredCases"
        :key="index"
        cols="4"
      >
        <case-card :caseInfo="caseInfo"></case-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name:'CaseList',

    components: {
      CaseCard: () => import('./CaseCard.vue')
    },

    props: {
      cases: { 
        type: Array,
        default: ()=>[] 
      },
      total: { 
        type: Number,
        default: 0
      },
      loading: { 
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        filter: {
          sort: {
            value: 'patient',
            options: [
              {
                text:'Sort by date modified',
                value:'date'
              },
              {
                text:'Sort by name',
                value:'patient'
              },
              {
                text:'Sort by case',
                value:'title'
              },
            ]
          },
          search: ''
        }
      }
    },

    computed: {
      filteredCases() {
        var sortProp = this.filter.sort.value
        var filtered = this.cases.filter(item => {
          var filter = this.filter.search.toLowerCase()
          return (
               item.patient.toLowerCase().includes(filter)
            || item.title.toLowerCase().includes(filter)
            || item.case_number.toLowerCase().includes(filter)
          )
        })
        var cases = filtered.sort(this.sortCases)
        return sortProp == 'date' ? cases.reverse() : cases
      }
    },

    methods: {
      /** HELPERS */
      sortCases(val1, val2) {
        var sortProp = this.filter.sort.value
        if (sortProp == 'date')
          return val1[sortProp].valueOf(val2[sortProp])
        else
          return val1[sortProp].localeCompare(val2[sortProp])
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>